import { useEffect, useState } from 'react'
import { WeaverLoading } from 'Components'
import withDetailsContainer from './withDetailsContainer'
import { getAttributeKeyLabel, getProjectData, getMemberKey, splitUid } from 'Services/WeaverUtils'
import { Tooltip } from 'antd'
import { relationAttributesRenderer } from './shared'

export default NodeDetails = ({ data }) ->
  [item, setItem] = useState(undefined)
  [loading, setLoading] = useState(true)

  useEffect( ->
    ( ->
      setLoading(true)
      [id, graph] = splitUid(data.wvrId || data.id)
      if graph?
        q = new Weaver.Query()
          .restrict([id])
          .inGraph(graph)
          .withRelations()
          .withAttributes()
      else
        q = new Weaver.Query()
          .restrict([id])
          .withRelations()
          .withAttributes()

      node = await q.first()

      setItem(node)
      setLoading(false)

    )()
    undefined
  , [data])

  return <WeaverLoading style={{ margin: '33%' }} /> if loading
  Details = withDetailsContainer(item, { nodeIsEditable: true })

  <Details>
    {
      _.chain(item._attributes)
      .map(({ _records }, key) ->
        _records.map(({ attNode, value }) ->
          {
            key: attNode.key
            label: <Tooltip title={key}>{ _.truncate(getAttributeKeyLabel(key), { length: 25 }) }</Tooltip>
            value
          }
        )
      ).flatten()
      .sortBy('key')
      .value()
      .concat(relationAttributesRenderer(item))
    }
  </Details>
